var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panels",
    { staticClass: "expansion" },
    [
      _c(
        "v-expansion-panel",
        [
          _c("v-expansion-panel-header", [
            _c("div", { staticClass: "expansion__header" }, [
              _c("img", {
                attrs: { src: _vm.item.src, width: "32px", height: "32px" },
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "expansion__title" }, [
                _vm._v(_vm._s(_vm.item.title)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "expansion__show-more" }, [
                _vm._v("Смотреть"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("v-expansion-panel-content", [
            _c(
              "ul",
              { staticClass: "expansion__list" },
              _vm._l(_vm.item.values, function (value) {
                return _c("li", { staticClass: "expansion__item" }, [
                  _vm._v(_vm._s(value)),
                ])
              }),
              0
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }